import React from 'react';
import {render} from 'react-dom';
import TestPage from './test-page';

const initTestPage = () => {
    document.body.style.margin = 0;

    const container = document.createElement('div');
    document.body.appendChild(container);

    render(<TestPage />, container);
};

document.addEventListener('DOMContentLoaded', initTestPage);



// WEBPACK FOOTER //
// ./scripts/test-page/index.js